import { Box, Skeleton, Stack } from '@mui/material';
import { DetailCard } from './DetailCard';
import { SummaryGrid } from './SummaryGrid';

export const SummaryCardSkeleton = ({ rows = 2 }) => (
  <DetailCard>
    <Stack spacing={2}>
      <Box>
        <Skeleton variant="text" width={140} height={18} />
        <Skeleton variant="rectangular" width="100%" height={22} />
      </Box>
      {Array.from({ length: rows }).map((_, row) => (
        <SummaryGrid key={row}>
          {[0, 1, 2].map(col => (
            <Box key={col}>
              <Skeleton variant="text" width={120} height={18} />
              <Skeleton variant="rectangular" width="80%" height={22} />
            </Box>
          ))}
        </SummaryGrid>
      ))}
    </Stack>
  </DetailCard>
);
